// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._077bee{min-width:3em;height:3em;position:relative;display:inline-block;vertical-align:middle}._8773c4{transform:rotate(-90deg)}.c902c2{fill:none;stroke-width:8;stroke-linecap:round}.f18e89{stroke:var(--primary)}._5fec62 .f18e89{transition:stroke-dashoffset .3s ease}.d489f1{stroke:var(--gray)}._87669d{left:50%;position:absolute;top:50%;transform:translate(-50%, -50%);font-size:.8em;line-height:1.2}._87669d small{display:block;font-size:.75em}", ""]);
// Exports
exports.locals = {
	"container": "_077bee",
	"circleContainer": "_8773c4",
	"element": "c902c2",
	"front": "f18e89 c902c2",
	"mounted": "_5fec62",
	"back": "d489f1 c902c2",
	"label": "_87669d"
};
module.exports = exports;
